import { ITableFieldDictionary } from 'src/app/interfaces/field-settings.interface';
import { DataTypes } from 'src/shared/enums/data-type.enum';

const CalibrationOfficeCommercial: ITableFieldDictionary = {
    OfficeMaxStories: { label: 'Maximum Office Levels', type: DataTypes.INTEGER },
    MaximumResidentialFAR: { label: 'Maximum Residential FAR', type: DataTypes.FLOAT },
    MaximumResidentialFLR: { label: 'Maximum Residential FLR', type: DataTypes.FLOAT },
    MaximumLodgingFAR: { label: 'Maximum Lodging FAR', type: DataTypes.FLOAT },
    MaximumLodgingFLR: { label: 'Maximum Lodging FLR', type: DataTypes.FLOAT },
    MaximumOfficeFLR: { label: 'Maximum Office FLR', type: DataTypes.FLOAT },
    MaximumOfficeFAR: { label: 'Maximum Office FAR', type: DataTypes.FLOAT },
    MaximumCommercialFAR: { label: 'Maximum Commercial FAR', type: DataTypes.FLOAT },
    MaximumCommercialFLR: { label: 'Maximum Commercial FLR', type: DataTypes.FLOAT },
    OfficeCommercialMaxStories: { label: 'Maximum Office and Commercial Levels', type: DataTypes.INTEGER },
    OfficeCommercialMaxPercentArea: { label: 'Office/Commercial Maximum Building %', type: DataTypes.FLOAT },
    CommercialEstabMaxArea: { label: 'Commercial Estab. Max. Area', type: DataTypes.FLOAT },
    CommercialFoodMaxSeating: { label: 'Commercial Food Max. Seating', type: DataTypes.FLOAT },
    DensityNet: { label: 'Maximum Residential Density', type: DataTypes.FLOAT },
    LodgingDensity: { label: 'Lodging Density', type: DataTypes.FLOAT },
    UnitAreaMin: { label: 'Dwelling Unit Average Minimum Gross Area', type: DataTypes.FLOAT },
    UnitAreaMax: { label: 'Dwelling Unit Average Maximum Gross Area', type: DataTypes.FLOAT },
    LodgingExchange: { label: 'Lodging Density Exchange', type: DataTypes.FLOAT },
    DensityUL: { label: 'Residential Density UL', type: DataTypes.BOOLEAN },
    LodgingDensityUL: { label: 'Lodging Density UL', type: DataTypes.BOOLEAN },
    Minimum1DwellingUnit: { label: 'Minimum 1 Dwelling Unit', type: DataTypes.BOOLEAN },
    IsLodgingExchangeEnabled: { label: 'Lodging Density Exchange Enabled', type: DataTypes.BOOLEAN },
    RoomAreaMin: { label: 'Lodging Room Average Minimum Gross Area', type: DataTypes.FLOAT },
    RoomAreaMax: { label: 'Lodging Room Average Maximum Gross Area', type: DataTypes.FLOAT },
    MaximumResidentialPercentArea: { label: 'Maximum Residential Area', type: DataTypes.FLOAT },
    MaximumLodgingPercentArea: { label: 'Maximum Lodging Area', type: DataTypes.FLOAT },
    MaximumOfficePercentArea: { label: 'Maximum Office Area', type: DataTypes.FLOAT },
    MaximumCommercialPercentArea: { label: 'Maximum Commercial Area', type: DataTypes.FLOAT },
    MaximumIndustrialPercentArea: { label: 'Maximum Industrial Area', type: DataTypes.FLOAT },
    MaximumIndustrialFAR: { label: 'Maximum Industrial FAR', type: DataTypes.FLOAT },
    MaximumIndustrialFLR: { label: 'Maximum Industrial FLR', type: DataTypes.FLOAT },
    MaximumCivicPercentArea: { label: 'Maximum Civic Area', type: DataTypes.FLOAT },
    MaximumCivicFAR: { label: 'Maximum Civic FAR', type: DataTypes.FLOAT },
    MaximumCivicFLR: { label: 'Maximum Civic FLR', type: DataTypes.FLOAT },
    MaximumCivicSupportPercentArea: { label: 'Maximum Civic Support Area', type: DataTypes.FLOAT },
    MaximumCivicSupportFAR: { label: 'Maximum Civic Support FAR', type: DataTypes.FLOAT },
    MaximumCivicSupportFLR: { label: 'Maximum Civic Support FLR', type: DataTypes.FLOAT },
    MaximumEducationalPercentArea: { label: 'Maximum Educational Area', type: DataTypes.FLOAT },
    MaximumEducationalFAR: { label: 'Maximum Educational FAR', type: DataTypes.FLOAT },
    MaximumEducationalFLR: { label: 'Maximum Educational FLR', type: DataTypes.FLOAT }
};

export default CalibrationOfficeCommercial;
